import { Cell, Section } from '@telegram-apps/telegram-ui'
import { IdCardLanyard, Package } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { LanguageSwitcher } from 'features/language-switcher'
import { Page } from 'shared/components/Page'
import { TezIdDialog } from 'shared/components/TezIdDialog'
import { useTranslate } from 'shared/lib/i18n'
import { useAuthStore } from 'shared/store/auth'

export function Profile() {
	const navigate = useNavigate()
	const { t } = useTranslate()
	const tezId = useAuthStore((s) => s.user.tezId)
	const [tezDialogOpen, setTezDialogOpen] = useState(false)

	return (
		<Page>
			<div className='account-page p-4'>
				<h1 className='mb-4 text-xl font-semibold text-foreground'>
					{t('navigation.profile')}
				</h1>

				<Section className='account-card'>
					<Cell
						Component='button'
						type='button'
						className='w-full text-left'
						onClick={() => setTezDialogOpen(true)}
						before={<IdCardLanyard aria-hidden size={22} />}
						after={
							tezId ? undefined : (
								<span className='relative flex size-2.5' aria-hidden>
									<span className='absolute inline-flex size-full animate-ping rounded-full bg-red-400 opacity-75' />
									<span className='relative inline-flex size-2.5 rounded-full bg-red-500' />
								</span>
							)
						}
					>
						<span className={tezId ? undefined : 'text-red-500'}>
							{tezId ? `TezId: ${tezId}` : t('pages.orders.addTezId')}
						</span>
					</Cell>
					<LanguageSwitcher />
					<Cell
						Component='button'
						type='button'
						className='w-full text-left'
						onClick={() => navigate('/orders')}
						before={<Package aria-hidden size={22} />}
					>
						{t('navigation.orders')}
					</Cell>
				</Section>
			</div>

			{tezDialogOpen && (
				<TezIdDialog
					open
					onOpenChange={setTezDialogOpen}
					initialValue={tezId ?? ''}
				/>
			)}
		</Page>
	)
}
